import React, { Component } from 'react';
import { Formik } from 'formik';
import { Form, FormGroup, InputGroup, Input, Button } from 'reactstrap';
import * as Yup from 'yup';
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { login, logoutUser } from "../../actions/AuthActions";
import Snackbar from '@material-ui/core/Snackbar';
import IconButton from '@material-ui/core/IconButton';
import CloseIcon from '@material-ui/icons/Close';
import Cookies from 'js-cookie';
import { Link } from 'react-router-dom';
import { configureStore } from './../../store';

//import { makeStyles } from '@material-ui/styles';
import './index.css';

// const useStyles = makeStyles(theme => ({
//   close: {
//     padding: theme.spacing(0.5),
//   },
// }));
const store = configureStore();

const ValidationSchema = Yup.object().shape({
  email: Yup.string()
    .email('Invalid email')
    .required('Please enter your e-mail'),
  password: Yup.string().required('Please enter a password'),
});

const FormFeedback = ({ valid, children }) => valid ? null : (
  <div className="formfeedback">
    {children}
  </div>
)

class Login extends Component {
  constructor() {
    super();
    this.state = {
      email: "",
      password: "",
      errors: {},
      openToast: false
    };

    if (Cookies.get('token') || Cookies.get('accessToken')) {
      // window.location = '/';
    }


  }

  handleClick = () => {
    this.setState({ openToast: true })
  };

  handleClose = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }

    this.setState({ openToast: false })
  };

  componentDidMount() {
    // If logged in and user navigates to Login page, should redirect them to dashboard
    if (this.props.auth.isAuthenticated) {
      store.dispatch(logoutUser());
    }
  }

  componentWillReceiveProps(nextProps) {
    const { auth, errors } = nextProps
    if (auth.isAuthenticated) {
      this.props.history.push("/employee-search");
    }
    if (!auth.isAuthenticated && errors) {
      this.setState({
        errors,
        openToast: true
      });
    }
  }

  onSubmit = user => {
    this.props.login(user);
  }

  render() {
    const { openToast } = this.state
    // const classes = useStyles();
    const { auth, errors } = this.props
    return (
      <div className="login-wrapper">
        <div className="logo-wrapper">
          <img src="/static/img/logo_login.png" alt="logo" width="100%" />
        </div>
        <div className="login-form">
        <h3 className="text-center">Login</h3>
          <Formik
            initialValues={{
              email: '',
              password: '',
            }}
            validationSchema={ValidationSchema}
            onSubmit={this.onSubmit}
          >
            {({ errors, touched, values, handleChange, handleSubmit, isValid, setTouched }) => (
              <Form
                method="post"
                onSubmit={handleSubmit} noValidate name='subscribeForm' style={{ marginTop: 25 }}>
                <FormGroup>
                  <InputGroup>
                    <Input type="email"
                      name="email"
                      id="email"
                      placeholder="Email Address"
                      autoFocus={false}
                      onChange={handleChange}
                      required
                      value={values.email} />
                    <div className="input-group-append">
                      <span className="input-group-text"><i className="fa fa-envelope"></i></span>
                    </div>
                    <FormFeedback valid={(errors.email) ? false : true}>{errors.email}</FormFeedback>
                  </InputGroup>
                </FormGroup>
                <FormGroup>
                  <InputGroup>
                    <Input type="password"
                      name="password"
                      id="password"
                      placeholder="Password"
                      autoFocus={false}
                      onChange={handleChange}
                      required
                      value={values.password} />
                    <FormFeedback valid={(errors.password) ? false : true}>{errors.password}</FormFeedback>
                  </InputGroup>
                </FormGroup>
                <FormGroup style={{ marginLeft: 10 }}>
                  <Link to={`/forgot-password`} style={{ fontSize: 15, }}>Forgot Password?</Link>
                  <Button
                    type="submit" color="success" className="mr-1" style={{ float: "right" }}>Sign In</Button>
                </FormGroup>
              </Form>
            )}
          </Formik>
        </div>
        <Snackbar
          anchorOrigin={{
            vertical: 'top',
            horizontal: 'center',
          }}
          open={openToast}
          autoHideDuration={3000}
          onClose={this.handleClose}
          ContentProps={{
            'aria-describedby': 'message-id',
          }}
          message={<span id="message-id">{errors.message}</span>}
          action={[
            <IconButton
              key="close"
              aria-label="close"
              color="inherit"
              // className={classes.close}
              onClick={this.handleClose}
            >
              <CloseIcon />
            </IconButton>,
          ]}
        />
      </div>
    );
  }
}

Login.propTypes = {
  login: PropTypes.func.isRequired,
  auth: PropTypes.object.isRequired,
  errors: PropTypes.object.isRequired
};

const mapStateToProps = state => ({
  auth: state.auth,
  errors: state.errors
});

export default connect(
  mapStateToProps,
  { login }
)(Login);




// WEBPACK FOOTER //
// ./client/src/views/Auth/login.js